module.exports = __webpack_public_path__ + "img/flower_leaf_15.c03c93f7.png";